import { IHttpService } from "../../core/service/HttpService";
import Constants from "../common/Constants";
import { ILegalView } from "../model/LegalView";
import LegalViewMapper from "./LegalViewMapper";
import LegalViewParamMapper from "./LegalViewParamMapper";

export interface ILegalViewService {
  createLegalView(item: ILegalView, indexes?: number[]): Promise<ILegalView>;
  updateLegalView(item: ILegalView, indexes: number[]): void;
  publishLegalView(legalViewId: number): void;
  archiveLegalView(legalViewId: number): void;
  revertLegalViewStatus(legalViewId: number): void;
}

const LegalViewService = ({ httpService }): ILegalViewService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  return {
    async createLegalView(item: ILegalView, indexes?: number[]) {
      const path = _http.buildPath(_baseUrl, Constants.endpointBasePath);
      const legalViewCreation = {
        legalView: LegalViewParamMapper(item),
        indexes: indexes
      };
      const response = await _http.post(path, {
        form: false,
        params: legalViewCreation
      });
      const responseJSON = await _http.toJSON(response);
      return LegalViewMapper(responseJSON);
    },
    async updateLegalView(item: ILegalView, indexes: number[]) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        item.id.toString()
      );
      const legalViewCreation = {
        legalView: LegalViewParamMapper(item),
        indexes: indexes
      };
      const response = await _http.put(path, {
        form: false,
        params: legalViewCreation
      });
      return _http.toText(response);
    },

    async publishLegalView(legalViewId: number) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        legalViewId.toString(),
        "publish"
      );
      await _http.post(path, {
        form: false
      });
    },

    async archiveLegalView(legalViewId: number) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        legalViewId.toString(),
        "archive"
      );
      await _http.post(path, {
        form: false
      });
    },

    async revertLegalViewStatus(legalViewId: number) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.endpointBasePath,
        legalViewId.toString(),
        "status-revert"
      );
      const response = await _http.post(path, {
        form: false
      });
      const responseJSON = await _http.toJSON(response);
      return LegalViewMapper(responseJSON);
    }
  };
};

export default LegalViewService;
